import Button from "../ui/Button";

// Custom buttons are declared by label ("Discard", "Save"), so the label is what
// identifies them in the DOM — kebab-cased so the id stays selector-safe.
const buttonId = (label) =>
  `ConfirmModal__button-${String(label)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")}`;

export default function ConfirmModal({
  onClose,
  title,
  message,
  buttons,
  type = "confirm",
}) {
  const handleConfirm = async () => {
    await onClose(true);
  };

  const handleCustomClick = async (callback) => {
    await callback();
    await onClose(true);
  };

  const types = {
    confirm: "bg-transparent text-secondary-foreground",
    warning: "bg-yellow-500/10 text-yellow-500",
    destructive: "bg-red-500/10 text-red-500",
  };

  return (
    <div
      id="ConfirmModal"
      className="w-full max-w-[500px] rounded-md flex flex-col bg-background border">
      <div
        className={`flex justify-between py-2 px-4 border-b items-center ${types[type]}`}>
        <span className="text-lg font-bold">{title}</span>
      </div>
      <div className="flex p-4 overflow-hidden">
        <span className="text-secondary-foreground text-sm whitespace-normal break-words">
          {message}
        </span>
      </div>
      <div className="flex justify-between p-2 ">
        <Button
          id="ConfirmModal__cancel"
          type="danger-ghost"
          className="min-w-20"
          onClick={onClose}>
          Cancel
        </Button>
        <div className="flex gap-2 items-center">
          {buttons ? (
            buttons.map((btn, i) => (
              <Button
                key={i}
                id={buttonId(btn.label)}
                type={btn.type || "primary"}
                className="min-w-20"
                onClick={() => handleCustomClick(btn.onClick)}>
                {btn.label}
              </Button>
            ))
          ) : (
            <Button
              id="ConfirmModal__confirm"
              type="primary"
              className="min-w-20"
              onClick={handleConfirm}>
              Confirm
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
